<template>
  <div class="cp-wrap">
    <h1>ComfortPages – Export</h1>

    <form class="export-form">
      <label>
        Export Format
        <select>
          <option value="csv">CSV</option>
          <option value="json">JSON</option>
          <option value="xml">XML</option>
        </select>
      </label>

      <button class="btn">Generate Export</button>
    </form>
  </div>
</template>

<script setup>
</script>

<style scoped>
.cp-wrap{
  max-width: 600px;
  margin: 2rem auto;
}
.export-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
